/**
 * 协议/隐私只读正文(W-20 / W-21,_shared)。
 * 居中可读宽度 + 浏览器原生滚动长文。
 * 纯只读:无 checkbox / 无「同意」按钮 / 无外链 / 无网络请求(与 App 一致)。
 * 正文常量与 App 同源(`@/common/copy/protocols`),不在此复制/改写条款。
 */
interface ProtocolViewProps {
  title: string;
  text: string;
  testId?: string;
}

export function ProtocolView({ title, text, testId }: ProtocolViewProps) {
  return (
    <div className="inner section">
      <div className="container-read">
        <h1 className="h2 mb-4">{title}</h1>
        <article
          data-testid={testId}
          className="sm"
          style={{
            whiteSpace: 'pre-wrap',
            lineHeight: 'var(--leading-relaxed, 1.75)',
            color: 'var(--color-foreground)',
          }}
        >
          {text}
        </article>
      </div>
    </div>
  );
}
